import { Box, Button, Dialog, Typography, Modal, Stack} from "@mui/material";
import { makeStyles } from '@mui/styles';
import { SnakeLoader } from "../loader/SnakeLoader";
import { VM } from '../VM'
import { MActionIcons } from "./Icons";

export const Confirmation = ({isOpen, cancel, send, disabled, text, btnText="Save"}) => {
    let view = VM()
    const styles = makeStyles(() => ({
        cancel: {
            backgroundColor: '#FFFFFF',
            color: '#1B1B1B',
            borderRadius: view === '/devices/mobile'|| view === '/devices/tablet' ? 4 : 12,
            border: '1px solid #7B7F82',
            height: view === '/devices/mobile'|| view === '/devices/tablet' ? 36 : 44,
            width: view === '/devices/mobile'|| view === '/devices/tablet'? 113 : 132,
            '&:hover':{
                backgroundColor: '#FFFFFF'
            }
        },
        send:{
            backgroundColor: '#ff0000',
            color: '#FFFFFF',
            borderRadius: view === '/devices/mobile'|| view === '/devices/tablet' ? 4 : 12,
            height: view === '/devices/mobile'|| view === '/devices/tablet' ? 36 : 44,
            width: view === '/devices/mobile'|| view === '/devices/tablet'? 113 : 132,
            '&:hover':{
                backgroundColor: '#ff0000'
            }
        }
    }))
    
    return (
        <Dialog open={isOpen} PaperProps={{ sx:{borderRadius: {xs: '8px !important', md: '14px !important'} } }}>
            <Box display="flex" alignItems="center" flexDirection="column" sx={{py: {xs: 3, md: 4}, px: {xs: 3, md:2,}, width: {md: 432}}}>
                <MActionIcons fill="#FD9797" />
                <Box py="32px" fontWeight="bold" fontSize={20} textAlign="center">{text}</Box>
                <Box display="flex">
                    <Button variant="contained" className={styles().cancel} sx={{mr: '12px'}} disableElevation={true} onClick={cancel} disabled={disabled}>Cancel</Button>
                    <Button variant="contained" className={styles().send} disableElevation={true} onClick={send} disabled={disabled}> { disabled  ? <SnakeLoader bg= "white" size= "10px" distance= "10px" /> : btnText } </Button>
                </Box>
            </Box>
        </Dialog>
    )
}

export const ConfirmationModal = ({ isOpen = true, title = 'Confirm Save', cancelFunc, sendFunc, text, saving, saveTxt = 'Save', type = 'normal' }) => {

	return (
		<Modal open={isOpen} /*onClose={handlerClose}*/ sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
			<Stack p='1.5rem' gap='1.25rem' sx={{ bgcolor: '#fff', borderRadius: '12px', minWidth: '20rem' }}>
				<MActionIcons fill={type === 'disabled' ? '#FD9797' : '#11783C'} width="40" height="40"/>
				<Stack gap='0.75rem'>
					<Typography fontWeight={600} sx={{ color: '#292C2F' }}>{title}</Typography>
					<Typography fontWeight={400} fontSize={14} sx={{ color: '#5B6167' }}>{text}</Typography>
				</Stack>
				<Stack direction='row' justifyContent='end' gap='0.5rem'>
					<Box sx={{ cursor: saving ? 'not-allowed' : 'pointer' }}>
						<Button variant="text" disabled={saving} onClick={cancelFunc} sx={{ fontWeight: '400', fontSize: '14px', color: type === 'disabled' ? '#292C2F' : 'primary.main', p: '0.5rem 1.5rem', boxShadow: 'none', border: 'none', borderRadius: '6px', '&:hover': { bgcolor: '#f8f9fa', boxShadow: 'none' } }}>Cancel</Button>
					</Box>
					<Box sx={{ cursor: saving ? 'not-allowed' : 'pointer' }}>
						<Button variant="contained" disabled={saving} onClick={sendFunc} sx={{ fontWeight: '400', fontSize: '14px', color: '#fff', bgcolor: type === 'disabled' ? '#ff0000' : 'primary.main', p: '0.5rem 1.5rem', boxShadow: 'none', border: 'none', borderRadius: '6px', cursor: saving ? 'not-allowed' : 'pointer', minHeight: '40.5px', '&:hover': { bgcolor: type === 'disabled' ? '#ff0000' : '#003022', boxShadow: 'none' } }}>
							{ saving ?
								<SnakeLoader size='6px' distance='4px' bg='#B5BBC1'/>
							:
								saveTxt
							}
						</Button>
					</Box>
				</Stack>
			</Stack>
		</Modal>
	)
}

